import {createSvgIcon} from '@yandex-delivery/blocks/icons/utils'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import React from 'react'

const className = css`
  inline-size: ${spacing(10.625)};
  block-size: ${spacing(10.625)};
`
export default createSvgIcon(
  <svg
    fill="none"
    height="87"
    viewBox="0 0 86 87"
    width="86"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="42.9477" cy="43.7329" fill="#FC3F1D" r="42.9477" />
    <path
      d="M49.2806 24.7971H44.9341C37.4829 24.7971 33.7572 28.5227 33.7572 34.1111C33.7572 40.3205 36.241 43.4252 41.8294 47.1508L46.1759 50.2555L33.7572 69.5045H23.8223L35.62 52.1183C28.7898 47.1508 25.0641 42.8042 25.0641 34.7321C25.0641 24.7971 31.8944 17.9668 44.9341 17.9668H57.9737V69.5045H49.2806V24.7971Z"
      fill="white"
    />
  </svg>,
  'YaLogo',
  {viewBox: '0 0 86 87', className},
)
